import React from 'react';

// Affichage compact des options structurées figées (reservation.selected_options).
export const SelectedOptionsSummary = ({ selectedOptions, className = '' }) => {
  const list = selectedOptions || [];
  if (!list.length) return null;
  return (
    <div className={`space-y-2 ${className}`} data-testid="selected-options-summary">
      {list.map((so, i) => {
        let totalPots = 0;
        let hasYield = false;
        (so.selections || []).forEach((g) => (g.choices || []).forEach((c) => {
          if (c.yield_per_batch_snapshot) { hasYield = true; totalPots += (c.batches || 1) * c.yield_per_batch_snapshot; }
        }));
        return (
          <div key={i} className="rounded-lg bg-[#A5BBA8]/10 border border-[#A5BBA8]/30 p-2.5">
            <p className="text-sm font-semibold text-[#2A312C]">
              {so.option_name} — {so.format_name}
            </p>
            <ul className="mt-1 space-y-0.5">
              {(so.selections || []).map((g, gi) => (
                (g.choices || []).map((c, ci) => (
                  <li key={`${gi}-${ci}`} className="text-xs text-[#5C6A61]">
                    <span className="text-[#5C6A61]">{g.group_name}:</span>{' '}
                    <span className="text-[#2A312C]">{c.name}</span>
                    {c.yield_per_batch_snapshot ? (
                      <span> — {c.batches || 1} lot(s) × {c.yield_per_batch_snapshot} = {(c.batches || 1) * c.yield_per_batch_snapshot} {c.yield_unit || 'pots'}</span>
                    ) : null}
                  </li>
                ))
              ))}
            </ul>
            {hasYield && so.included_batches != null && (
              <p className="text-xs font-medium text-[#2A312C] mt-1">Total : {so.included_batches} lot(s) / {totalPots} pots</p>
            )}
          </div>
        );
      })}
    </div>
  );
};
